import { render, staticRenderFns } from "./hotspot.vue?vue&type=template&id=54b477de&scoped=true&"
import script from "./hotspot.vue?vue&type=script&lang=js&"
export * from "./hotspot.vue?vue&type=script&lang=js&"
import style0 from "./hotspot.vue?vue&type=style&index=0&id=54b477de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b477de",
  null
  
)

export default component.exports